import { SectionHeading } from '../../../packs/CarContent/components/SectionHeading'

export const InternalLinks = ({ internalLinks, title }) => (
  <div>
    <SectionHeading title={title} />
    <ul className="row list-unstyled justify-content-center">
      {internalLinks.map((link) => (
        <li className="col-6 col-md-3 my-2" key={`internal-link-${link.id}`}>
          <a
            href={link.destinationable.path}
            className="btn btn-white shadow h-100 d-flex align-items-center justify-content-center"
          >
            {link.title.replace('for sale', I18n.t('cars.index.for_sale'))}
          </a>
        </li>
      ))}
    </ul>
  </div>
)
